import { Product } from './product';

export class EmbeddedBOQCoatProduct {
	product: Product;
	applicationMethod: string;
	percentage: number;
	targetRate?: number;
	spreadRate?: number;
}
